import React, { Component } from 'react'
import Layout from 'components/Layout'
import { ExchangeList } from './style'
import { getPartialSteps, setFlowStepperStep } from 'components/Steps/thunk'
import { clearShippingOptions } from 'components/Steps/slices'
import { connect } from 'react-redux'
import config from 'configs/config'
//import RelatedProducts from 'components/ReconvertionProducts'
import {
	addBackUrl,
	addContinueUrl,
	updateContinueState,
} from 'components/Footer/thunk'
import { deletePartialNewOrder } from 'components/Steps/slices'
import { bindActionCreators } from 'redux'
import StepsAnimation from 'components/StepsAnimation'
import { LoaderSpinner } from '../../components/Loader'
import ExchangeItemsList from './components/ExchangeItemsList'
import { difference } from '../../utils/common'

class Exchange extends Component {
	constructor(props) {
		super(props)
		this.state = {
			filledItems: {},
		}
		this.animatedItemId = null
	}

	componentDidMount() {
		this.props.setFlowStepperStep('EXCHANGE')
		this.props.deletePartialNewOrder()
		this.props.clearShippingOptions()
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		let {
			flowStep = {},
			items,
			partialRequestData = {},
			nextFlowStep,
			prevFlowStep,
			isLoading,
		} = this.props
		if (
			(prevProps.flowStep !== flowStep ||
				prevProps.items.newExchange !== items.newExchange) &&
			flowStep === config.flowSteps.EXCHANGE
		) {
			console.log('flowSteps', flowStep)
			this.props.getPartialSteps(partialRequestData)
		}
		if (
			prevProps.flowStep !== flowStep ||
			prevProps.nextFlowStep !== nextFlowStep ||
			prevProps.prevFlowStep !== prevFlowStep
		) {
			const { nextFlowStep, prevFlowStep } = this.props
			// continue button url functionality
			this.props.addContinueUrl(nextFlowStep)
			this.props.addBackUrl(prevFlowStep)
		}

		if (prevProps.items.newExchange !== items.newExchange) {
			let objectDifference = difference(
				items.newExchange,
				prevProps.items.newExchange
			)
			let animatedId = Object.keys(objectDifference)[0]
			this.animatedItemId = animatedId
		}

		if (
			prevProps.isLoading !== isLoading &&
			isLoading === false &&
			this.animatedItemId
		) {
			let self = this
			let animationElement = document.getElementById(this.animatedItemId)
			let cloneAnimationElement = animationElement.cloneNode(true)
			animationElement.parentNode.appendChild(cloneAnimationElement)

			cloneAnimationElement.classList.add('visible')
			cloneAnimationElement.classList.add('startMotion')

			setTimeout(() => {
				cloneAnimationElement.classList.remove('startMotion')
				cloneAnimationElement.classList.add('runMotionPosition')
				self.animatedItemId = null
				setTimeout(() => {
					cloneAnimationElement.parentNode.removeChild(
						cloneAnimationElement
					)
				}, 1000)
			}, 950)
		}

		//this.handleContinueState(prevProps)
	}

	exchangeList = (items) => {
		return (
			[
				...Object.values(items.exchange),
				...Object.values(items.refund),
				...Object.values(items.reclamation),
			].sort(
				(a, b) => !!b.IsExchangeMandatory - !!a.IsExchangeMandatory
			) || []
		)
	}

	render() {
		const { items = {}, isLoading = false } = this.props
		return (
			<Layout>
				<StepsAnimation>
					<ExchangeList>
						<LoaderSpinner isActive={isLoading} />
						<ExchangeItemsList
							list={this.exchangeList(items)}
							exchangeItems={this.props.items.newExchange}
						/>
					</ExchangeList>
					<div id='exchange-list-item-pusher'></div>
					{/*<RelatedProducts items={this.exchangeList(items)} />*/}
				</StepsAnimation>
			</Layout>
		)
	}
}

function mapStateToProps({ steps }) {
	return {
		items: steps.items,
		isLoading: steps.isLoading,
		flowStep: steps.flowStep,
		partialRequestData: steps.partialRequestData,
		nextFlowStep: steps.nextFlowStep,
		prevFlowStep: steps.prevFlowStep,
	}
}

function matchDispatchToProps(dispatcher) {
	return bindActionCreators(
		{
			getPartialSteps,
			setFlowStepperStep,
			addContinueUrl,
			updateContinueState,
			deletePartialNewOrder,
			addBackUrl,
			clearShippingOptions,
		},
		dispatcher
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(Exchange)
